var _path, _path2, _path3, _path4, _path5, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTaxcrypLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 40,
    viewBox: "0 0 47 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5406 21.9238H36.9219V25.5506H46.5406V21.9238Z",
    fill: "url(#paint0_radial_502_9)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5406 16.8135H36.9219V20.4402H46.5406V16.8135Z",
    fill: "url(#paint1_radial_502_9)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000433922 25.5498H9.61914V21.9231H0.000433922V25.5498Z",
    fill: "url(#paint2_radial_502_9)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.000433922 20.4404H9.61914V16.8137H0.000433922V20.4404Z",
    fill: "url(#paint3_radial_502_9)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7276 10.5786V31.7278L27.3201 39.9837V20.7742H35.5178V14.4091H11.0233V20.7742H19.2621V40L4.81348 31.7278V10.5786L23.2705 0L41.7276 10.5786Z",
    fill: "url(#paint4_radial_502_9)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_502_9",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.8665 20.7095) scale(12.1569 12.0619)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#003477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#004185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#005196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#0066A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#006EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#005FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#004F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#003D77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00326A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#002E65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#163582"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_502_9",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.8665 20.7092) scale(12.1569 12.0619)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#003477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#004185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#005196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#0066A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#006EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#005FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#004F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#003D77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00326A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#002E65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#163582"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_502_9",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.9133 21.214) scale(25.3405 25.1426)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#003477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#004185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#005196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#0066A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#006EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#005FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#004F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#003D77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00326A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#002E65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#163582"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_502_9",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.9133 21.2147) scale(25.3405 25.1426)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#003477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#004185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#005196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#0066A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#006EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#005FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#004F8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#003D77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#00326A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#002E65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#163582"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_502_9",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.2706 20) scale(19.3278 19.1769)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#005FA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#0069AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#006EAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#0069AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#005196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#004382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#00346D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002E65"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxcrypLogoSmall);
export default __webpack_public_path__ + "static/media/taxcrypLogoSmall.118fcc28dc68995c923e1a9e322d731f.svg";
export { ForwardRef as ReactComponent };